/**object to pass data to backend to verify user by security question answer
 */ 
 let User_PasswordReset_Object = {
   "id": "",
   "questionId": "",
   "securityAns": "",
   "securityQst": ""
};

export {User_PasswordReset_Object};